import React from 'react';
import { FaExclamationTriangle } from "react-icons/fa";

const DeleteConfirmationModal = ({ isOpen, onCancel, onConfirm, countdown, isDeleting }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay p-8">
            <div className="modal cards center" style={{ height: "300px" }}>
                <div className="warning2">
                    <FaExclamationTriangle className="warning-icon2" />
                </div>
                <p className='pt-16'>VARNING!</p>
                <p className='pt-16'>Du är på väg att PERMANENT radera ditt övningskort!</p>

                <div className="modal-buttons pt-16 pt-32 cards">
                    <button className='ghostbutton' onClick={onCancel}>Avbryt</button>
                    {!isDeleting ? (
                        <button className='ghostbutton' onClick={onConfirm}>
                            Radera
                        </button>
                    ) : (
                        <button className='ghostbutton' onClick={onCancel}>
                            Ångra? {countdown}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
